/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface StatusResponse {
    /**
     * The current server time in UTC
     * @format date-time
     */
    timestamp: string;
    isUp: boolean;
    /** Top level assembly version */
    assemblyVersion?: string | null;
    /** Application Assembly Name */
    application?: string | null;
    /** Application Run Environment */
    environment?: string | null;
}

export interface AuditTrailResponse {
    loanId?: string | null;
    loanEvents?: AuditRecord[] | null;
}

/**
 * Audit Record that will be published with each change saved to the load application in DB.
 * Example record - When: date, Type: 'Decision', SubtType: 'Approved', Amount: null, AvailabeCredit: null,
 * Example record - When: date, Type: 'Authorization', SubtType: 'Requested', Amount: 5000, AvailabeCredit: 10000
 * Example record - When: date, Type: 'Authorization', SubtType: 'Approved', Amount: 5000, AvailabeCredit: 5000 (reduced due to captured auth)
 * Example record - When: date, Type: 'Charge', SubtType: 'Requested', Amount: 5000, AvailabeCredit: 5000 (not reduced since its charging authed amount)
 * Example record - When: date, Type: 'Charge', SubtType: 'Approved', Amount: 5000, AvailabeCredit: 5000 not reduced since its charging authed amount, or for some providers
 * like greensky it will be reduced since authing and charging is done in one shot)
 */
export interface AuditRecord {
    /** What happened on the loan. */
    type: AuditEventType;
    /** Additional info when applicable */
    subType: AuditEventSubType;
    /**
     * When it happened
     * @format date-time
     */
    when: string;
    /**
     * not null when relevant (like auth or charge)
     * @format decimal
     */
    amount?: number | null;
    /**
     * Always show the updated available credit
     * @format decimal
     */
    availableCredit?: number | null;
}

export enum AuditEventType {
    NotSet = 'notSet',
    Decision = 'decision',
    Signature = 'signature',
    Authorization = 'authorization',
    Charge = 'charge',
    ChangeOrder = 'changeOrder',
}

export enum AuditEventSubType {
    NotSet = 'notSet',
    Pending = 'pending',
    Approved = 'approved',
    Rejected = 'rejected',
}

export interface CustomerResponse {
    id?: string | null;
    name?: string | null;
}

export interface DashboardModel {
    tenantId?: string | null;
    overview?: OverviewType | null;
    revenue?: RevenueType | null;
    operatingMetrics?: OperatingMetricsType | null;
    technicianPerformance?: TechnicianPerformanceItem[] | null;
    planApplicationSource?: PlanApplicationSourceType | null;
}

export interface OverviewType {
    financingRevenue?: KpiModel | null;
    approvalRate?: KpiModel | null;
    revenueFromFinancing?: KpiModel | null;
    averageTicketSize?: KpiModel | null;
    closeRate?: KpiModel | null;
}

export interface KpiModel {
    /** @format double */
    value: number;
    /** @format double */
    trend?: number | null;
    /** @format double */
    percentage: number;
}

export interface RevenueType {
    completedRevenue?: KpiModel | null;
    financingRevenue?: KpiModel | null;
    revenueFromFinancing?: KpiModel | null;
    chartData?: DataObject[] | null;
}

export interface DataObject {
    field?: string | null;
    value?: string | null;
    aggregates?: Record<string, AggregateItem>;
}

export interface AggregateItem {
    field?: string | null;
    /** @format double */
    value: number;
}

export interface OperatingMetricsType {
    totalJobs?: KpiModel | null;
    closeRate?: KpiModel | null;
    jobsFinanced?: KpiModel | null;
    financingRate?: KpiModel | null;
    valueOfLostJobs?: KpiModel | null;
    ticketSizeChartData?: DataObject[] | null;
    jobConversionChartData?: DataObject[] | null;
}

export interface TechnicianPerformanceItem {
    name?: string | null;
    /** @format int32 */
    jobsCount: number;
    /** @format double */
    totalRevenue: number;
    /** @format double */
    averageTicketSize: number;
    /** @format double */
    closeRate: number;
    /** @format double */
    valueOfLostJobs: number;
    /** @format double */
    estimatePresentRate: number;
    /** @format double */
    viewFinancingRate: number;
    /** @format double */
    applicationSubmitRate: number;
}

export interface PlanApplicationSourceType {
    applicationSourceChartData?: DataObject[] | null;
    planPerformanceSummary?: PlanPerformanceItem[] | null;
}

export interface PlanPerformanceItem {
    plan?: string | null;
    planDescription?: string | null;
    partner?: string | null;
    /** @format int32 */
    applications: number;
    /** @format double */
    totalApproved: number;
    /** @format double */
    averageLoan: number;
    /** @format double */
    percentOfTotalAppsSubmitted: number;
    /** @format double */
    approvalRate: number;
}

export enum CustomerType {
    Residential = 'residential',
    Commercial = 'commercial',
    All = 'all',
}

export interface JobAmountRange {
    /** @format decimal */
    from: number;
    /** @format decimal */
    to: number;
}

/** Represents the data to fill in for the financing dashboard filters */
export interface FiltersInfo {
    tenantId?: string | null;
    /** Business Unit id and name for the tenant */
    businessUnits?: KeyValuePairOfStringAndString[] | null;
    /** Enabled providers for the tenant */
    providerNames?: string[] | null;
    /** Technicians id and name for the tenant */
    technicians?: KeyValuePairOfStringAndString[] | null;
    /** Technicians id and name for the tenant */
    jobTypes?: KeyValuePairOfStringAndString[] | null;
}

export interface KeyValuePairOfStringAndString {
    key?: string | null;
    value?: string | null;
}

export interface LOANAPPLICATION {
    /** @format decimal */
    applicationrequestedamount: number;
    /** @format decimal */
    applicationapprovedamount: number;
    applicationstatus?: string | null;
    applicationplanid?: string | null;
    applicationplandesc?: string | null;
    applicationfinancingprovider?: string | null;
    /** @format int32 */
    applicationsourceid: number;
    applicationsource?: string | null;
}

export type MetricsExportMetricsAsInSampleData = any;

export type MetricsExportMetricsAsInDocsData = any;

export type StatusGetData = StatusResponse;

export type StatusMetricsData = any;

export interface AuditTrailsGetLoanAuditTrailParams {
    tenantId?: string | null;
    loanId: string;
}

export type AuditTrailsGetLoanAuditTrailData = AuditTrailResponse;

export interface AuditTrailsGetLoanAuditTrail2Params {
    tenantId?: string | null;
    loanId: string;
}

export type AuditTrailsGetLoanAuditTrail2Data = AuditTrailResponse;

export interface CustomersGetCustomersParams {
    tenantId?: string | null;
    customerIds?: string | null;
}

export type CustomersGetCustomersData = CustomerResponse[];

export interface CustomersGetCustomers2Params {
    tenantId?: string | null;
    customerIds?: string | null;
}

export type CustomersGetCustomers2Data = CustomerResponse[];

export interface DashboardsGetParams {
    /** The tenants id */
    TenantId?: string | null;
    /**
     * Represents the starting date in the query.
     * @format date-time
     */
    From: string;
    /**
     * Represents the ending date in the query.
     * @format date-time
     */
    To: string;
    /** Represents the from and ending date timezone in the query. Default to UTC.  */
    TimeZone?: string | null;
    /** Customer type i.e. Residential or Commercial or both */
    CustomerType: CustomerType;
    /** True :Exclude all the jobs with amount '0', otherwise include in case of FALSE */
    ExcludeJobWithZeroAmount: boolean;
    /** Filters the job by job amount range. */
    JobAmountRangeFilter?: JobAmountRange[] | null;
    /** Filters the job by division */
    DivisionFilter?: string[] | null;
    /** Filters the job by business units. */
    BusinessUnitFilter?: string[] | null;
    /** Filters the job by financing provider type. */
    FinancingProviderFilter?: string[] | null;
    /** Filters the job by job type. */
    JobTypeFilter?: string[] | null;
    /** Filters the job by technician. */
    TechnicianFilter?: string[] | null;
}

export type DashboardsGetData = DashboardModel;

export interface DashboardsGet2Params {
    /** The tenants id */
    TenantId?: string | null;
    /**
     * Represents the starting date in the query.
     * @format date-time
     */
    From: string;
    /**
     * Represents the ending date in the query.
     * @format date-time
     */
    To: string;
    /** Represents the from and ending date timezone in the query. Default to UTC.  */
    TimeZone?: string | null;
    /** Customer type i.e. Residential or Commercial or both */
    CustomerType: CustomerType;
    /** True :Exclude all the jobs with amount '0', otherwise include in case of FALSE */
    ExcludeJobWithZeroAmount: boolean;
    /** Filters the job by job amount range. */
    JobAmountRangeFilter?: JobAmountRange[] | null;
    /** Filters the job by division */
    DivisionFilter?: string[] | null;
    /** Filters the job by business units. */
    BusinessUnitFilter?: string[] | null;
    /** Filters the job by financing provider type. */
    FinancingProviderFilter?: string[] | null;
    /** Filters the job by job type. */
    JobTypeFilter?: string[] | null;
    /** Filters the job by technician. */
    TechnicianFilter?: string[] | null;
}

export type DashboardsGet2Data = DashboardModel;

export interface DashboardsGet3Params {
    /** The tenants id */
    TenantId?: string | null;
    /**
     * Represents the starting date in the query.
     * @format date-time
     */
    From: string;
    /**
     * Represents the ending date in the query.
     * @format date-time
     */
    To: string;
    /** Represents the from and ending date timezone in the query. Default to UTC.  */
    TimeZone?: string | null;
    /** Customer type i.e. Residential or Commercial or both */
    CustomerType: CustomerType;
    /** True :Exclude all the jobs with amount '0', otherwise include in case of FALSE */
    ExcludeJobWithZeroAmount: boolean;
    /** Filters the job by job amount range. */
    JobAmountRangeFilter?: JobAmountRange[] | null;
    /** Filters the job by division */
    DivisionFilter?: string[] | null;
    /** Filters the job by business units. */
    BusinessUnitFilter?: string[] | null;
    /** Filters the job by financing provider type. */
    FinancingProviderFilter?: string[] | null;
    /** Filters the job by job type. */
    JobTypeFilter?: string[] | null;
    /** Filters the job by technician. */
    TechnicianFilter?: string[] | null;
}

export type DashboardsGet3Data = DashboardModel;

export type TenantsGetFinancingDashboardFiltersData = FiltersInfo;

export type TenantsGetFinancingDashboardFilters2Data = FiltersInfo;

export type TenantsGetFinancingDashboardFilters3Data = FiltersInfo;

export interface ViewGetLoanApplicationsParams {
    tenantId?: string | null;
}

export type ViewGetLoanApplicationsData = LOANAPPLICATION;

import { inject, injectable, optional, symbolToken } from '@servicetitan/react-ioc';
import axios, { AxiosRequestConfig, AxiosResponse, ResponseType } from 'axios';
import { v4 as uuidv4 } from 'uuid';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<
    AxiosRequestConfig,
    'data' | 'params' | 'url' | 'responseType'
> {
    /** set parameter to `true` for call `securityWorker` for this request */
    secure?: boolean;
    /** request path */
    path: string;
    /** content type of request body */
    type?: ContentType;
    /** query params */
    query?: QueryParamsType;
    /** format of response (i.e. response.json() -> format: "json") */
    format?: ResponseType;
    /** request body */
    body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export enum ContentType {
    Json = 'application/json',
    FormData = 'multipart/form-data',
    UrlEncoded = 'application/x-www-form-urlencoded',
    Text = 'text/plain',
}

export enum RequestOrigin {
    Unknown = 'Unknown',
    Mobile = 'Mobile',
    Desktop = 'Desktop',
    BackgroundJob = 'BackgroundJob',
    Webhook = 'Webhook',
    Redirect = 'Redirect',
    CustomerPortal = 'CustomerPortal',
    CustomerPortal2 = 'CustomerPortal2',
    FMA = 'FMA',
    CPB = 'CPB',
}

@injectable()
export class HttpClient {
    sessionId: string;
    tenantId: string;
    tenantFriendlyName: string;
    actingUserId: string;
    requestOrigin: RequestOrigin;
    financingProvider: string = 'Unspecified';

    constructor(
        sessionId: string,
        tenantId: string,
        tenantFriendlyName: string,
        actingUserId: string,
        requestOrigin: RequestOrigin,
    ) {
        this.sessionId = sessionId;
        this.tenantId = tenantId;
        this.tenantFriendlyName = tenantFriendlyName;
        this.actingUserId = actingUserId;
        this.requestOrigin = requestOrigin;
    }

    public setFinancingProvider(provider: string) {
        this.financingProvider = provider;
    }

    protected stringifyFormItem(formItem: unknown) {
        if (typeof formItem === 'object' && formItem !== null) {
            return JSON.stringify(formItem);
        } else {
            return `${formItem}`;
        }
    }

    protected createFormData(input: Record<string, unknown>): FormData {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            const propertyContent: any[] = property instanceof Array ? property : [property];

            for (const formItem of propertyContent) {
                const isFileType = formItem instanceof Blob || formItem instanceof File;
                formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
            }

            return formData;
        }, new FormData());
    }

    public request = async <T = any, _E = any>({
        secure,
        path,
        type,
        query,
        format,
        body,
        ...params
    }: FullRequestParams): Promise<AxiosResponse<T>> => {
        const responseFormat = format;

        if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
            body = this.createFormData(body as Record<string, unknown>);
        }

        if (type === ContentType.Text && body && body !== null && typeof body !== 'string') {
            body = JSON.stringify(body);
        }

        return axios.request({
            ...params,
            headers: {
                ...(params.headers || {}),
                ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
                'X-ST-SessionId': this.sessionId,
                'X-ST-CorrelationId': uuidv4(),
                'X-ST-TenantId': this.tenantId,
                'X-ST-TenantFriendlyName': this.tenantFriendlyName,
                'X-ST-ActingUserId': this.actingUserId,
                'X-ST-FIN-Origin': this.requestOrigin,
                'X-ST-FIN-Provider': this.financingProvider,
            },
            params: query,
            responseType: responseFormat,
            data: body,
            url: path,
            paramsSerializer: { indexes: null },
        });
    };
}

export const SESSION_ID_FintechDataApi = symbolToken<string>('SESSION_ID', false);
export const TENANT_ID_FintechDataApi = symbolToken<string>('TENANT_ID', false);
export const TENANT_FRIENDLY_NAME_FintechDataApi = symbolToken<string>(
    'TENANT_FRIENDLY_NAME',
    false,
);
export const ACTING_USER_ID_FintechDataApi = symbolToken<string>('ACTING_USER_ID', false);
export const REQUEST_ORIGIN_FintechDataApi = symbolToken<string>('REQUEST_ORIGIN', false);

export const BASE_URL_TOKEN_FintechDataApi = symbolToken<string>('BASE_URL_TOKEN', false);

/**
 * @title Fintech Data
 * @version v1
 * @baseUrl http://localhost:9000
 */
@injectable()
export class FintechDataApi extends HttpClient {
    constructor(
        @inject(SESSION_ID_FintechDataApi) @optional() sessionId: string,
        @inject(TENANT_ID_FintechDataApi) @optional() tenantId: string,
        @inject(TENANT_FRIENDLY_NAME_FintechDataApi) @optional() tenantFriendlyName: string,
        @inject(ACTING_USER_ID_FintechDataApi) @optional() actingUserId: string,
        @inject(REQUEST_ORIGIN_FintechDataApi) @optional() requestOrigin: RequestOrigin,
        @inject(BASE_URL_TOKEN_FintechDataApi) @optional() private readonly baseUrl = '',
    ) {
        super(sessionId, tenantId, tenantFriendlyName, actingUserId, requestOrigin);
    }

    public setFinancingProvider(provider: string): void {
        super.setFinancingProvider(provider);
    }

    /**
     * No description
     *
     * @tags Metrics
     * @name MetricsExportMetricsAsInSample
     * @summary Exports metrics as in the sample
     * @request GET:/metrics/-exported
     */
    metricsExportMetricsAsInSample = (params: RequestParams = {}) =>
        this.request<MetricsExportMetricsAsInSampleData, any>({
            path: `/metrics/-exported`,
            method: 'GET',
            baseURL: this.baseUrl,
            ...params,
        });

    /**
     * No description
     *
     * @tags Metrics
     * @name MetricsExportMetricsAsInDocs
     * @summary Exports metrics as in the docs
     * @request GET:/metrics
     */
    metricsExportMetricsAsInDocs = (params: RequestParams = {}) =>
        this.request<MetricsExportMetricsAsInDocsData, any>({
            path: `/metrics`,
            method: 'GET',
            baseURL: this.baseUrl,
            ...params,
        });

    /**
     * No description
     *
     * @tags Status
     * @name StatusGet
     * @summary An easy way to run health checks
     * @request GET:/status
     */
    statusGet = (params: RequestParams = {}) =>
        this.request<StatusGetData, void>({
            path: `/status`,
            method: 'GET',
            baseURL: this.baseUrl,
            ...params,
        });

    /**
     * No description
     *
     * @tags Status
     * @name StatusMetrics
     * @request GET:/status/metrics
     */
    statusMetrics = (params: RequestParams = {}) =>
        this.request<StatusMetricsData, any>({
            path: `/status/metrics`,
            method: 'GET',
            baseURL: this.baseUrl,
            ...params,
        });

    /**
     * No description
     *
     * @tags AuditTrails
     * @name AuditTrailsGetLoanAuditTrail
     * @summary Returns the loan audit trail
     * @request GET:/v1/audit-trails/loans/{loanId}
     */
    auditTrailsGetLoanAuditTrail = (
        { loanId, ...query }: AuditTrailsGetLoanAuditTrailParams,
        params: RequestParams = {},
    ) =>
        this.request<AuditTrailsGetLoanAuditTrailData, void>({
            path: `/v1/audit-trails/loans/${loanId}`,
            method: 'GET',
            baseURL: this.baseUrl,
            query: query,
            ...params,
        });

    /**
     * No description
     *
     * @tags Customers
     * @name CustomersGetCustomers
     * @summary Returns customers
     * @request GET:/v1/customers
     */
    customersGetCustomers = (query: CustomersGetCustomersParams, params: RequestParams = {}) =>
        this.request<CustomersGetCustomersData, void>({
            path: `/v1/customers`,
            method: 'GET',
            baseURL: this.baseUrl,
            query: query,
            ...params,
        });

    /**
     * No description
     *
     * @tags Dashboards
     * @name DashboardsGet
     * @summary Returns the loan application view
     * @request GET:/v1/dashboards
     */
    dashboardsGet = (query: DashboardsGetParams, params: RequestParams = {}) =>
        this.request<DashboardsGetData, void>({
            path: `/v1/dashboards`,
            method: 'GET',
            baseURL: this.baseUrl,
            query: query,
            ...params,
        });

    /**
     * No description
     *
     * @tags Tenants
     * @name TenantsGetFinancingDashboardFilters
     * @summary Returns the loan application view
     * @request GET:/v1/tenants/{id}/filters
     */
    tenantsGetFinancingDashboardFilters = (id: string, params: RequestParams = {}) =>
        this.request<TenantsGetFinancingDashboardFiltersData, void>({
            path: `/v1/tenants/${id}/filters`,
            method: 'GET',
            baseURL: this.baseUrl,
            ...params,
        });

    /**
     * No description
     *
     * @tags View
     * @name ViewGetLoanApplications
     * @summary Returns the loan application view
     * @request GET:/v1/view/loans
     */
    viewGetLoanApplications = (query: ViewGetLoanApplicationsParams, params: RequestParams = {}) =>
        this.request<ViewGetLoanApplicationsData, void>({
            path: `/v1/view/loans`,
            method: 'GET',
            baseURL: this.baseUrl,
            query: query,
            ...params,
        });

    /**
     * No description
     *
     * @tags AuditTrails
     * @name AuditTrailsGetLoanAuditTrail2
     * @summary Returns the loan audit trail
     * @request GET:/api/fintech-data/v1/audit-trails/loans/{loanId}
     */
    auditTrailsGetLoanAuditTrail2 = (
        { loanId, ...query }: AuditTrailsGetLoanAuditTrail2Params,
        params: RequestParams = {},
    ) =>
        this.request<AuditTrailsGetLoanAuditTrail2Data, void>({
            path: `/api/fintech-data/v1/audit-trails/loans/${loanId}`,
            method: 'GET',
            baseURL: this.baseUrl,
            query: query,
            ...params,
        });

    /**
     * No description
     *
     * @tags Customers
     * @name CustomersGetCustomers2
     * @summary Returns customers
     * @request GET:/api/fintech-data/v1/customers
     */
    customersGetCustomers2 = (query: CustomersGetCustomers2Params, params: RequestParams = {}) =>
        this.request<CustomersGetCustomers2Data, void>({
            path: `/api/fintech-data/v1/customers`,
            method: 'GET',
            baseURL: this.baseUrl,
            query: query,
            ...params,
        });

    /**
     * No description
     *
     * @tags Dashboards
     * @name DashboardsGet2
     * @summary Returns the loan application view
     * @request GET:/api/financing/dashboards/v1/dashboards
     */
    dashboardsGet2 = (query: DashboardsGet2Params, params: RequestParams = {}) =>
        this.request<DashboardsGet2Data, void>({
            path: `/api/financing/dashboards/v1/dashboards`,
            method: 'GET',
            baseURL: this.baseUrl,
            query: query,
            ...params,
        });

    /**
     * No description
     *
     * @tags Dashboards
     * @name DashboardsGet3
     * @summary Returns the loan application view
     * @request GET:/api/fintech-data/v1/dashboards
     */
    dashboardsGet3 = (query: DashboardsGet3Params, params: RequestParams = {}) =>
        this.request<DashboardsGet3Data, void>({
            path: `/api/fintech-data/v1/dashboards`,
            method: 'GET',
            baseURL: this.baseUrl,
            query: query,
            ...params,
        });

    /**
     * No description
     *
     * @tags Tenants
     * @name TenantsGetFinancingDashboardFilters2
     * @summary Returns the loan application view
     * @request GET:/api/financing/dashboards/v1/tenants/{id}/filters
     */
    tenantsGetFinancingDashboardFilters2 = (id: string, params: RequestParams = {}) =>
        this.request<TenantsGetFinancingDashboardFilters2Data, void>({
            path: `/api/financing/dashboards/v1/tenants/${id}/filters`,
            method: 'GET',
            baseURL: this.baseUrl,
            ...params,
        });

    /**
     * No description
     *
     * @tags Tenants
     * @name TenantsGetFinancingDashboardFilters3
     * @summary Returns the loan application view
     * @request GET:/api/fintech-data/v1/tenants/{id}/filters
     */
    tenantsGetFinancingDashboardFilters3 = (id: string, params: RequestParams = {}) =>
        this.request<TenantsGetFinancingDashboardFilters3Data, void>({
            path: `/api/fintech-data/v1/tenants/${id}/filters`,
            method: 'GET',
            baseURL: this.baseUrl,
            ...params,
        });
}
